import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5ddd02d2&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navigation: require('/Users/markussh/git/theodora-tech-website/src/components/navigation/Navigation.vue').default,SectionWrapper: require('/Users/markussh/git/theodora-tech-website/src/components/section/Wrapper.vue').default})
